import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationTriangle,
  faHandshake,
  faSkullCrossbones,
} from '@fortawesome/free-solid-svg-icons';

// Stripe Payment Links for PRODUCTION
/*const STRIPE_LINKS = {
  100: 'https://buy.stripe.com/aFa00c5Bw7C70xT4P204800',
  200: 'https://buy.stripe.com/test_200...',
  500: 'https://buy.stripe.com/test_500...',
  1000: 'https://buy.stripe.com/test_500...',
};*/
// Stripe Payment Links for TESTING
const STRIPE_LINKS = {
  100: 'https://buy.stripe.com/test_aFa00c5Bw7C70xT4P204800',
  200: 'https://buy.stripe.com/test_3cI3co1lg9Kf3K5a9m04801',
  500: 'https://buy.stripe.com/test_4gM14gd3Y1dJbcxa9m04802',
  1000: 'https://buy.stripe.com/test_6oU3cofc63lR4O9dly04803',
};

const WalletBanner = ({ balance, companyId, isAdmin }) => {
  // 1. Invisible State: Balance is healthy
  if (balance === undefined || balance > 10) return null;

  // Configuration for the banner based on thresholds
  let config = {};

  if (balance <= 10 && balance > 0) {
    config = {
      bg: '#f5d400',
      color: '#333',
      icon: faExclamationTriangle,
      title: 'LOW BALANCE WARNING',
      msg: `Your workspace wallet is down to ($${balance.toFixed(2)}). Please ask your Admin to top up the account to continue using Influencersforce AI workloads.`,
    };
  } else if (balance <= 0 && balance > -25) {
    config = {
      bg: '#f57c00',
      color: '#fff',
      icon: faHandshake,
      title: 'COURTESY LOAN ACTIVE',
      msg: `Zero balance reached. We've granted a $25 courtesy loan to keep your team working. Current balance: ($${balance.toFixed(2)}). Please top up immediately to continue using Influencersforce AI workloads. `,
    };
  } else if (balance <= -25 && balance > -50) {
    config = {
      bg: '#d32f2f',
      color: '#fff',
      icon: faSkullCrossbones,
      title: 'CRITICAL BALANCE',
      msg: `Courtesy loan exhausted ($${balance.toFixed(2)}). Service will be suspended at any moment. Please ask your Admin to Top up immediately to continue using Influencersforce AI workloads..`,
    };
  } else {
    return null; // If <= -50, the SuspensionScreen takes over completely.
  }

  // Automatically append the company ID so the Webhook knows who paid!
  const getCheckoutUrl = (amount) =>
    `${STRIPE_LINKS[amount]}?client_reference_id=${companyId}`;

  return (
    <div
      style={{
        backgroundColor: config.bg,
        color: config.color,
        padding: '0.75rem 1rem',
        textAlign: 'center',
        fontSize: '0.9rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '15px',
      }}
    >
      <strong>
        <FontAwesomeIcon icon={config.icon} /> {config.title}:
      </strong>
      <span>{config.msg}</span>

      {isAdmin ? (
        <div style={{ display: 'flex', gap: '10px' }}>
          <a
            href={getCheckoutUrl(100)}
            target="_blank"
            rel="noreferrer"
            style={btnStyle(config.color)}
          >
            + $100
          </a>
          <a
            href={getCheckoutUrl(200)}
            target="_blank"
            rel="noreferrer"
            style={btnStyle(config.color)}
          >
            + $200
          </a>
        </div>
      ) : (
        <span style={{ fontStyle: 'italic', fontSize: '0.8em', opacity: 0.8 }}>
          (Contact your Company Admin to top up)
        </span>
      )}
    </div>
  );
};

const btnStyle = (textColor) => ({
  backgroundColor: textColor === '#fff' ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.1)',
  color: textColor,
  padding: '4px 12px',
  borderRadius: '4px',
  textDecoration: 'none',
  fontWeight: 'bold',
  fontSize: '0.8rem',
  border: `1px solid ${textColor}`,
});

export default WalletBanner;
